export default "__VITE_ASSET__3f1ded86__"